import axios from './axios';

export function getTokenBySessionId(sessionId) {
    return axios.get(`/auth/token`, {
        params: { sessionId }
    }).then(res => res.data);
}

export function verifyToken() {
    return axios.get('/auth/verify').then(res => res.status === 200);
}

export function logout() {
    return axios.post('/auth/logout').then(res => res.status === 200);
}

export function refreshToken() {
    return axios.post('/auth/token/refresh').then(res => res.status === 200);
}

export function getMemberById(id) {
    return axios.get(`/member/${id}`).then(res => res.data);
}

// 更新角色與狀態
export function updateRoleAndStatus(id, data) {
    return axios.put(`/member/${id}/role-status`, data).then(res => res.status === 204);
}

// 🔍 查詢會員分頁
export function getMemberPage(queryRequest, pageable = { page: 0, size: 10 }) {
    const params = {
        ...queryRequest,
        ...pageable
    };
    return axios.get('/member/page', { params }).then(res => res.data);
}
